/**
 * @version 1.0
 * @author xieyq
 * @createTime 2021/9/2
 * @updateTime 2021/9/2
 * @decription
 * @namespace 【】
 */
// 表单布局
import acLayoutForm from '@/components/app/layout/form/index.vue';
// 标题栏
import acTitleBar from '@/components/app/title-bar/index.vue';
// 选择申请人
import selectSQR from './select-SQR/index.vue';
import {columnsSFZ} from '@/utils/option.js';
import {columnsDLRLX} from '@/utils/option.js';
import {
    typeDlrlx,
    typeSfzjlx
} from '@/filters/index';
import validate from '@/utils/validator/validator';
import {
    dlrlxRule,
    XmRule,
    zjlxRule,
    ZjhmRule,
    PhoneRule,
    ZyzjhmRule,
    LsRule, sqrRule
} from '@/utils/validator/rules';
import {createId} from "@/utils/common";
// 工具类js
import utils from '../../js/utils.js';

export default {
    components: {
        acLayoutForm,
        acTitleBar,
        selectSQR
    },
    props: {
        // 申请人数据列表
        sqrDataList: Array,
        // 表单数据
        data: Object
    },
    // 注入
    inject: ['fromSQBG'],
    data() {
        return {
            // 是否显示所属申请人id弹层
            show: false,
            // 表单数据
            formData: {
                // 代理人主键ID
                cId: '',
                // 申请人id数组
                cBqSqrids: [],
                //申请人idid
                cBqSqrid:'',
                //申请人id姓名
                cSqrText:'',
                //代理人性别
                cDlrxb:'1',
                // 代理人类型
                cDlrlx: '1',
                // 代理人类型文本
                cDlrlxText: '',
                // 代理人姓名
                cDlrxm: '',
                // 代理人证件类型
                cDlrzjlx: '1',
                // 代理人证件类型文本
                cDlrzjlxText: '',
                // 代理人证件号码
                cDlrzjh: '',
                // 代理人执业证件号码
                cDlrzjhm: '',
                // 代理人所在律所
                cDlrszls: '',
                // 固定电话
                cGddh: '',
                // 手机号码
                cPhone: ''
            },
            columnsSFZ: Object.freeze(columnsSFZ),
            columnsDLRLX: Object.freeze(columnsDLRLX),
            // 证件类型
            showZjlxPicker: false,
            // 代理人类型
            showDlrlxPicker: false
        }
    },
    methods: {

        // 返回
        back() {
            this.$emit('cancel');
        },

        /**
         * 选择证件类型
         * @param {Object} item 选中的信息项
         * @returns {void}
         * */
        onZjlxConfirm(item) {
            this.showZjlxPicker = false;
            this.formData.cDlrzjlxText = item.text;
            this.formData.cDlrzjlx = item.keyId;
        },

        /**
         * 选择代理人类型
         * @param {Object} item 选中的信息项
         * @returns {void}
         * */
        onDlrlxConfirm(item) {
            // 赋值
            this.showDlrlxPicker = false;
            // 如果选择的同一个，则直接返回
            if (item.keyId == this.formData.cDlrlx) {
                return;
            }
            // 清空部分数据
            let obj = {
                cDlrxm: '',
                cDlrxb: '1',
                cDlrzjh: '',
                cPhone: '',
                cDlrzjhm: '',
                cDlrszls: '',
                cGddh: ''
            };
            Object.keys(obj).forEach(key => {
                this.formData[key] = obj[key];
            })
            this.formData.cDlrlxText = item.text;
            this.formData.cDlrlx = item.keyId;
        },

        /**
         * 显示选择申请人
         * @returns {void}
         * */
        showSelectSQR() {
            this.show = true;
        },

        /**
         * 隐藏申请人选择
         * @returns {void}
         * */
        hideSelectSQR() {
            this.show = false;
        },

        /**
         * 申请人选择确认
         * @param {Array} checkedDataList 选中的数据列表
         * @returns {void}
         * */
        onConfirmSelectSQR(checkedDataList) {
            // 申请人id列表
            const _sqrIds = [];
            const _sqrText = [];
            checkedDataList.forEach(item => {
                _sqrIds.push(item[this.fromSQBG ? 'cYdbSqrid' : 'cId']);
                // 申请人名称
                _sqrText.push(utils.getSqrMc(item));
            });
            // 申请人id数组
            this.formData.cBqSqrids = _sqrIds;
            // 保存申请人id
            this.formData.cBqSqrid = _sqrIds.join(',');
            // 申请人姓名
            this.formData.cSqrText = _sqrText.join(',');
            // 隐藏选择申请人
            this.hideSelectSQR();
        },

        /**
         * 添加/确认按钮点击事件
         * @returns {void}
         * */
        addAndReturn() {
            // 验证表单
            this.validateFormData().then(() => {
                // 向上分发确认事件
                this.$emit('confirm', this.formData);
            }).catch(() => {
                console.log('校验不通过！');
            });
        },

        /**
         * 重置数据
         * */
        resetData() {
            // 重置formData数据
            this.formData = {
                // 代理人主键ID
                cId: '',
                    //复议主表ID
                    cFyId: this.fyid,
                    // 申请人id数组
                    cBqSqrids: [],
                    //申请人idid
                    cBqSqrid:'',
                    //申请人id姓名
                    cSqrText:'',
                    //代理人性别
                    cDlrxb:'1',
                    // 代理人类型
                    cDlrlx: '1',
                    // 代理人类型文本
                    cDlrlxText: '',
                    // 代理人姓名
                    cDlrxm: '',
                    // 代理人证件类型
                    cDlrzjlx: '1',
                    // 代理人证件类型文本
                    cDlrzjlxText: '',
                    // 代理人证件号码
                    cDlrzjh: '',
                    // 代理人执业证件号码
                    cDlrzjhm: '',
                    // 代理人所在律所
                    cDlrszls: '',
                    // 固定电话
                    cGddh: '',
                    // 手机号码
                    cPhone: ''
            }
        },

        /**
         * 刷新表单
         * */
        refresh() {
            // 重置数据
            this.resetData();
            // 初始化方法
            this.init();
        },

        /**
         * 确认并添加按钮点击事件
         * @returns {void}
         * */
        addAndContinue() {
            // 验证表单数据
            this.validateFormData().then(() => {
                // 向上分发确认并继续事件
                this.$emit('confirm-continue', this.formData);
                // 刷新表单
                this.refresh();
            }).catch(() => {
                console.log('校验不通过！');
            });
        },

        /**
         * 校验form表单
         * @returns {Promise}
         * */
        validateFormData() {
            let descriptor = {
                // 申请人id
                cBqSqrid: sqrRule,
                // 代理人类型
                cDlrlx: dlrlxRule,
                // 代理人姓名
                cDlrxm: new XmRule(true),
                // 证件类型
                cDlrzjlx: zjlxRule,
                // 证件号码
                cDlrzjh: new ZjhmRule(this.formData.zjlx, true),
                // 手机号码
                cPhone: new PhoneRule(true)
            };
            // 代理人类型为1 律师
            if (this.formData.cDlrlx == 1) {
                // 执业律师校验规则
                descriptor.cDlrzjhm = new ZyzjhmRule(true);
                descriptor.cDlrszls = new LsRule(true);
            }
            let validated = validate(descriptor, this.formData);
            return validated;
        },

        /**
         * 初始化方法
         * @returns {void}
         * */
        init() {
            // 如果数据存在
            if (this.data) {
                // 数据进行赋值
                const _formData = {
                    ...this.data
                };
                // 表单赋值
                this.formData = _formData;
            } else {
                // 创建id
                createId().then(id => {
                    this.formData.cId = id;
                    // 设置是属于新增
                    this.formData.isAdd = true;
                });
            }
            // 代理人类型
            this.formData.cDlrlxText = typeDlrlx(this.formData.cDlrlx);
            // 证件类型
            this.formData.cDlrzjlxText = typeSfzjlx(this.formData.cDlrzjlx);
            // 保全申请人id
            const _sqrIds = this.formData.cBqSqrid ? this.formData.cBqSqrid.split(',') : [];
            // 赋值申请人id数组，因为后台接口该值可能为null
            this.formData.cBqSqrids = _sqrIds.slice(0);
            // 查找到对应的申请人id，赋值对应的名称
            if (_sqrIds && _sqrIds.length && this.sqrDataList && this.sqrDataList.length) {
                // 申请人文本数组
                let _cSqrTexts = [];
                this.sqrDataList.every(item => {
                    if (!_sqrIds.length) {
                        return false;
                    }
                    // 对应的索引index
                    const _index = _sqrIds.indexOf(item[this.fromSQBG ? 'cYdbSqrid' : 'cId']);
                    if (_index > -1) {
                        // 如果是自然人，则取申请人名称，否则取企业名称
                        _cSqrTexts.push(utils.getSqrMc(item));
                        // 删除对应的id
                        _sqrIds.splice(_index, 1);
                    }
                    return true;
                });
                this.formData.cSqrText = _cSqrTexts.join(',');
            }
        }
    },
    created() {
      // 初始化
      this.init();
    }
}
